import { BaseCustomElement } from "brut-js"

class SplitDropdown extends BaseCustomElement {
  static tagName = "cc-split-dropdown"

  static observedAttributes = [
    "show-warnings",
    "disabled",
  ]

  #disabled = false

  disabledChangedCallback({newValueAsBoolean}) {
    this.#disabled = newValueAsBoolean
  }

  #withMenu(code) {
    const menu = this.querySelector("[role='menu']")

    if (menu) {
      code(menu)
    }
    else {
      this.logger.warn("No role=menu found - drop down will not work")
    }
  }

  #toggleClickListener = (event) => {
    event.preventDefault()

    const button = event.currentTarget
    if (button.hasAttribute("aria-expanded")) {
      this.#close(button)
    }
    else {
      this.#open(button)
    }
  }

  #documentClickListener = (event) => {
    if (!this.contains(event.target)) {
      this.querySelectorAll("[aria-expanded]").forEach((button) => {
        this.#close(button)
      })
    }
  }

  #close(button) {
    this.#withMenu((menu) => {
      menu.style.display = "none"
      button.removeAttribute("aria-expanded")
    })
  }

  #open(button) {
    this.#withMenu((menu) => {
      menu.style.display = "block"
      button.setAttribute("aria-expanded", "true")
    })
  }

  update() {
    const toggleButton = this.querySelector("[aria-haspopup]")
    if (!toggleButton) {
      this.logger.warn("No button with aria-haspopup found - drop down will not work")
      return
    }
    if (this.#disabled) {
      toggleButton.setAttribute("disabled", "true")
      toggleButton.removeEventListener("click", this.#toggleClickListener)
      document.removeEventListener("click", this.#documentClickListener)
      this.querySelectorAll("button").forEach( (button) => {
        button.setAttribute("disabled", "true")
      })
    }
    else {
      toggleButton.addEventListener("click", this.#toggleClickListener)
      document.addEventListener("click", this.#documentClickListener)
      this.querySelectorAll("button").forEach( (button) => {
        button.removeAttribute("disabled")
      })
    }
  }


}
export default SplitDropdown
